import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=4a3d1da8&"
import script from "./Prescription.vue?vue&type=script&lang=ts&"
export * from "./Prescription.vue?vue&type=script&lang=ts&"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=4a3d1da8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports